// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import axios from "axios";
import router from "./router";
import "lib-flexible";
import Vant from "vant";
import "@vant/touch-emulator";
import "vant/lib/index.css";
import { Tree, Select, Option } from "element-ui";
import smoothscroll from "smoothscroll-polyfill";
import "regenerator-runtime/runtime";
smoothscroll.polyfill();
Select.computed.readonly = function() {
  // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));

  return !(this.filterable || this.multiple || !isIE) && !this.visible;
};
Vue.component(Tree.name, Tree);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
import common from "./assets/js/common.js";
import VideoPlayer from "vue-video-player";
import { fetch, baseURL } from "./config/fetch.js";
import language from "./assets/js/language.js";
import store from "./store/";
import i18n from "./i18n";
import { isChunkLoadError, reloadForChunkError } from "./assets/js/chunkLoad.js";
//引入nprogress
import NProgress from "nprogress"; // 进度条
import "nprogress/nprogress.css"; //这个样式必须引入
import htmlToImg from "@/components/utils/htmlToImg";
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToImg);
Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(VideoPlayer);

// 部署后旧 chunk 失效 / 异步组件加载失败时自动刷新，避免偶发白屏
Vue.config.errorHandler = function(err, vm, info) {
  if (isChunkLoadError(err)) {
    reloadForChunkError();
    return;
  }
  if (typeof console !== "undefined" && console.error) {
    console.error("[Vue error]", info, err);
  }
};

window.addEventListener("unhandledrejection", function(event) {
  var reason = event && event.reason;
  if (isChunkLoadError(reason)) {
    event.preventDefault();
    reloadForChunkError();
  }
});

// Vue.config.ignoredElements.push('wx-open-launch-weapp')

window.fetch = fetch;
window.baseURL = baseURL;
window.common = common;
window.language = language;
window.NProgress = NProgress;
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
Vue.use(VXETable);
// progress配置
NProgress.configure({ easing: "ease", speed: 500, showSpinner: false });
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.fullPath == "/vascularNews/meeting/index?meeting_id=399") {
    next("/CVSCF2023/index");
    return;
  }
  if (to.fullPath == "/vascularNews/meeting/index?meeting_id=483") {
    next("/XVC/index");
    return;
  }

  if (to.fullPath == "/vascularNews/meeting/index?meeting_id=385") {
    next("/TECross2023/index");
    return;
  }
  NProgress.start();
  next();
});
router.afterEach((to, from) => {
  NProgress.done();
});

router.onError(err => {
  if (isChunkLoadError(err)) {
    reloadForChunkError();
  }
});

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js